import clsx from 'clsx';
import IconArrowDown from '@/assets/icons/icon-arrow-down-01.svg?react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import IconSettings from '@/assets/icons/icon-settings.svg?react';
import { TextField } from '@/components/inspector-fields/TextField/TextField';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

interface StylesGeneralSettingsProps {
  className: string;
  onClick?: () => void;
  isOpenCollapse: boolean;
  onDataChange: (data: { label: string }) => void;
  value: string;
  isReadOnly?: boolean;
}

export const StylesGeneralSettings: React.FC<StylesGeneralSettingsProps> = ({
  className = '',
  onClick,
  isOpenCollapse,
  onDataChange,
  value,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <Collapsible defaultOpen={isOpenCollapse} className={clsx(className)}>
      <CollapsibleTrigger
        onClick={handleClick}
        className={clsx(
          'group bg-neutral-0 w-full cursor-pointer border-t border-neutral-100 px-2 py-4',
        )}
      >
        <div className="flex w-full items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <IconSettings className="h-4 w-4 text-neutral-900" />
            <span className="text-button-sm text-neutral-900">General Settings</span>
          </div>
          <IconArrowDown className="h-4 w-4 text-neutral-500 transition-all group-data-[state=open]:rotate-180" />
        </div>
      </CollapsibleTrigger>

      <CollapsibleContent className={clsx('bg-neutral-0 w-full py-3')}>
        <div className="flex flex-col gap-2 p-2">
          <div className="flex w-full items-center gap-1">
            <span className="font-['Inter'] text-xs leading-none font-medium text-neutral-500">
              Style Name
            </span>
          </div>
          {isReadOnly ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <TextField
                    className="flex w-full flex-col items-start gap-3"
                    classNameInputParent="w-full max-w-full"
                    inputValue={value}
                    placeholderText="New Style"
                    state="default"
                    text=""
                    type="text"
                    disabled
                  />
                </div>
              </TooltipTrigger>
              <TooltipContent side="top" className="max-w-[200px] text-white">
                Rename your brand kit in the Brand section of your dashboard.
              </TooltipContent>
            </Tooltip>
          ) : (
            <TextField
              className="flex w-full flex-col items-start gap-3"
              classNameInputParent="w-full max-w-full"
              inputValue={value}
              placeholderText="New Style"
              state="default"
              text=""
              type="text"
              autoFocus
              onChange={(e) => onDataChange({ label: e.target.value })}
            />
          )}
        </div>

        {!isReadOnly && (
          <div className="flex flex-col items-start px-2 text-[10px] font-medium text-neutral-400">
            <p>Keep this under 30 characters.</p>
          </div>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
};
